<template>
	<form class="app" @submit.prevent="submit" :class="{'loading': loading}">
		<div class="row">
			<div class="left-col">
				<p>Здесь можно подать объявление в бегущую строку</p>

				<hr>

				<p><b>Цена за символ: {{ price }} ₽ в сутки</b></p>
				<p class="label mb-12">Объявления</p>
				<div class="switch">
					<button v-for="cat in categories"
							:key="cat.id"
							class="switch__btn"
							:class="{'switch__btn--active': cat === category}"
							type="button"
							@click="category = cat">
						{{ cat.name }}
					</button>
					<button
						type="button"
						class="switch__quest"
						@click="questions = true">
						<svg enable-background="new 0 0 512 512" fill="#aaa" version="1.1" viewBox="0 0 512 512" width="20px" height="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
							<circle cx="256" cy="378.5" r="25"/>
							<path d="m256 0c-141.48 0-256 114.5-256 256 0 141.48 114.5 256 256 256 141.48 0 256-114.5 256-256 0-141.48-114.5-256-256-256zm0 472c-119.38 0-216-96.607-216-216 0-119.38 96.607-216 216-216 119.38 0 216 96.607 216 216 0 119.38-96.607 216-216 216z"/>
							<path d="m256 128.5c-44.112 0-80 35.888-80 80 0 11.046 8.954 20 20 20s20-8.954 20-20c0-22.056 17.944-40 40-40s40 17.944 40 40-17.944 40-40 40c-11.046 0-20 8.954-20 20v50c0 11.046 8.954 20 20 20s20-8.954 20-20v-32.531c34.466-8.903 60-40.26 60-77.469 0-44.112-35.888-80-80-80z"/>
						</svg>
					</button>
					<div
						class="switch__out"
						v-if="questions"
						@click.self="questions = false">
						<div
							class="switch__modal"
							v-show="questions">
							<div class="switch__modal--head">
								<h5>Коммерческие и некоммерческие объявления</h5>
								<div @click="questions = false">
									<svg aria-hidden="true" focusable="false" width="20px" height="20px" data-prefix="fac" data-icon="close" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg-inline--fa fa-close fa-w-16"><path fill="#aaa" d="M13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 1.414-1.414L12 10.586l5.293-5.293a1 1 0 0 1 1.414 1.414L13.414 12z" class=""></path></svg>
								</div>
							</div>
							<div class="switch__modal--main">
								<p>Праивльно выберите тип объявления.<p>
								<p>От этого будет зависеть стоимость слова и начало времени суток выхода объявления.</p>
								<ul>
									<li>
										<p><b>НЕКОММЕРЧЕСКИЕ ОБЪЯВЛЕНИЯ</b> выходят в рубриках «НЕДВИЖИМОСТЬ», «РАБОТА», «ТРАНСПОРТ», «ЖИВОТНЫЙ МИР», «ПОТЕРИ», «СООБЩЕНИЯ».</p>
										<p>Текст НЕКОММЕРЧЕСКОГО ОБЪЯВЛЕНИЯ не содержит информации, связанной с предпринимательской деятельностью.</p>
										<p>Время начала суток может быть выбрано самостоятельно.</p>
									</li>
									<li>
										<p><b>Объявления, связанные с получением прибыли, являются КОММЕРЧЕСКИМИ ОБЪЯВЛЕНИЯМИ.</b></p>
										<p>Особенность выхода в эфир: сутки выхода начинаются с 0:00, поэтому подача заранее - за один рабочий день.</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<template v-if="currentPath.length">
					<template v-for="cat in currentPath">
						<custom-multiselect
							v-if="cat.offsprings && cat.offsprings.length"
							:key="cat.id"
							class="mt-24"
							v-model="cat.current"
							:options="cat.offsprings"
							label="name"
							track-by="id"
						/>
					</template>
				</template>
				<label class="label mt-40 mb-12" :class="{'invalid': !contentValid}" for="text">
					Содержание объявления
					<textarea
						v-model="content"
						class="field mt-8"
						name="text" id="text"
						@input="contentValid = true"
						:class="{'uppercase': capital}"
					/>
					<span class="feedback">
                        Пожалуйста, введите текст объявления
                    </span>
				</label>
				<label class="label" style="max-width: 410px; width: 100%;" :class="{'invalid': !phoneValid}">
					<span class="mb-8">Телефон, который будет указан в объявлении</span>
					<input
						type="text"
						class="field"
						v-model="phone"
						@input="phoneValid = true"
						v-mask="'+7(###) ###-##-##'"
						placeholder="+7(999) 999-99-99"
					/>
					<span class="feedback">
                        Нужно заполнить это поле
                    </span>
				</label>
				<label class="check">
					<input type="checkbox" v-model="capital">
					<span class="check-ico">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.8 448.8"><polygon points="142.8 323.9 35.7 216.8 0 252.5 142.8 395.3 448.8 89.3 413.1 53.6" fill="#FFFFFF"/></svg>
                    </span>
					Все заглавные
				</label>
				<div class="counts">
					{{ wordCount }} <span class="small">слов</span> = <span class="color-orange">{{ sum }} <span class="small">рублей</span></span>
				</div>
				<!--                <button class="btn outlined mt-16" type="button">Сохранить</button>-->
			</div>
		</div>
		<div class="mt-64">
			<h2>Расчет стоимости</h2>
			<div v-for="discount in discounts" :key="discount.id">
				Акция! При подаче объявления на каждые
				{{ discount.count_days }} {{ declOfNum(discount.count_days, ['день', 'дня', 'дней']) }} -
				{{ discount.extra_days }} {{ declOfNum(discount.extra_days, ['день', 'дня', 'дней']) }}
				<template v-if="discount.factor > 0">
					скидка {{ (1 - discount.factor) * 100 }} %!
				</template>
				<template v-else>
					в подарок!
				</template>
			</div>
			<table class="mt-16">
				<tr>
					<th>Слов</th>
					<th>Период размещения</th>
					<th>Цена, руб.</th>
				</tr>
				<tr>
					<td>{{ wordCount }}</td>
					<td :class="{'invalid': !dateValid}">
						<div>
							<span class="circle" style="background: #F57A02"></span> - Обычные дни
							<span class="circle" style="background: #2c72d6; margin-left: 20px;"></span> - Дни по акции
						</div>
						<flat-pickr
							@input="dateValid = true"
							v-model="date"
							:config="flatpickrConfig"
							placeholder="Выберите дату"
							autocomplete="off"
						/>
						<div class="feedback">
							Пожалуйста, выберите дату
						</div>
					</td>
					<td>{{ totalSum }}</td>
				</tr>
			</table>
			<p>
				Дней по акции: <span class="big-yellow">{{ discountDays }}.</span>
			</p>
			<p>
				Еще один день будет стоить: <span class="big-yellow">{{ nextDayCost }} руб.</span>
			</p>
			<div class="row mt-32">
				<label class="label" style="max-width: 380px; margin-right: 24px; width: 100%" :class="{'invalid': !userNameValid}">
					<span class="mb-8">Представьтесь, пожалуйста</span>
					<input type="text" class="field" v-model="userName" @input="userNameValid = true">
					<span class="feedback">
                        Нужно заполнить это поле
                    </span>
				</label>
				<label class="label" style="max-width: 260px; width: 100%;" :class="{'invalid': !userPhoneValid}">
					<span class="mb-8">Телефон для связи</span>
					<input
						type="text"
						class="field"
						v-model="userPhone"
						@input="userPhoneValid = true"
						v-mask="'+7(###) ###-##-##'"
						placeholder="+7(999) 999-99-99"
					/>
					<span class="feedback">
                        Нужно заполнить это поле
                    </span>
				</label>
			</div>
			<label class="check">
				<input type="checkbox" v-model="agree">
				<span class="check-ico">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.8 448.8">
						<polygon
							points="142.8 323.9 35.7 216.8 0 252.5 142.8 395.3 448.8 89.3 413.1 53.6"
							fill="#FFFFFF"/>
					</svg>
				</span>
				С правилами оплаты ознакомлен(a)
			</label>
			<div class="error-message">
				{{ errorMessage }}
			</div>
			<button class="btn fill mt-32" type="submit" :disabled="!agree">
				Оплатить
			</button>

			<br>

			<button
				type="button"
				class="toggle-info"
				@click="showTerms = !showTerms"
			>
				<template v-if="!showTerms">
					Правила оплаты
				</template>
				<template v-else>
					Свернуть
				</template>
			</button>

			<TheTerms v-show="showTerms"/>

		</div>
	</form>
</template>

<script>
	import CustomMultiselect from "./CustomMultiselect";
	import TheInfo from "./TheInfo";
	import TheTerms from "./TheTerms";

	function formatDate(date) {
		let day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		let month = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		return date.getFullYear() + '-' + month + '-' + day;
	}

	if (Array.isArray(window.serverData.categories)) {
		let setCurrent = function(el) {
			el.current = el.offsprings[0];
			if (Array.isArray(el.offsprings)) {
				el.offsprings.forEach(setCurrent);
			}
		};
		window.serverData.categories.forEach(setCurrent);
	}

	let minDate = 0;
	let curDate = new Date(window.serverData.date);
	if (curDate.getHours() >= 15) {
		curDate.setDate(curDate.getDate() + 1);
	}
	if (curDate.getDay() > 5) {
		minDate = curDate.getTime() + 1000 * 60 * 60 * 24 * (8 - curDate.getDay());
	} else {
		minDate = curDate.getTime();
	}
	minDate = formatDate(new Date(minDate)).split('-').reverse().join('.');

	export default {
		name: 'App',
		components: {TheTerms, TheInfo, CustomMultiselect},
		data() {
			return {
				loading: false,
				errorMessage: '',
				capital: false,
				wordCount: 0,
				categories: window.serverData.categories,
				category: window.serverData.categories[0],

				content: '',
				contentValid: true,
				phone: '',
				phoneValid: true,
				date: '',
				dateValid: true,
				userName: '',
				userNameValid: true,
				userPhone: '',
				userPhoneValid: true,

				discountDays: 0,
				nextDayCost: 0,


				flatpickrConfig: {
					mode: 'multiple',
					dateFormat: 'd.m.Y',
					minDate: minDate,
					onDayCreate: (dObj, dStr, fp, dayElem) => {
						let date = formatDate(dayElem.dateObj);
						if (this.daysMap[date]) {
							dayElem.classList.add('bg-border-blue');
						}
					}
				},
				daysMap: {},

				showInfo: false,
				agree: false,
				showTerms: false,
				questions: false,
			}
		},
		computed: {
			currentPath() {
				let path = [];
				let cat = this.category;
				while (cat) {
					path.push(cat);
					cat = cat.current;
				}
				return path;
			},
			price() {
				let curCat = this.currentPath[this.currentPath.length - 1];
				return this.capital ? curCat.capital_price : curCat.price;
			},
			daysCount() {
				if (!this.date) {
					return 1;
				}
				let dates = this.date.split(/[^\d.]+/g);
				return dates.length;
			},
			sum() {
				return this.wordCount * this.price;
			},
			totalSum() {
				let days = this.daysCount;
				let price = this.sum;
				let sums = [0];
				let choices = [];
				for (let i = 1; i <= days + 1; i++) {
					sums[i] = sums[i - 1] + price;
				}
				for (let day = 1; day <= days + 1; day++) {
					this.discounts.forEach((discount) => {
						let shouldBuy = discount.count_days;
						let discountDays = discount.extra_days;
						let factor = discount.factor;
						for (let freeDays = 1; freeDays <= discountDays; freeDays++) {
							if (freeDays + shouldBuy <= day) {
								let curSum = sums[day - (freeDays + shouldBuy)] + freeDays * factor * price + shouldBuy * price;
								if (curSum < sums[day]) {
									sums[day] = curSum;
									choices[day] = {
										discount: discount,
										freeDays,
									}
								}
							}
						}
					})
				}
				this.nextDayCost = sums[days + 1] - sums[days] || 0;

				let daysTypes = [];
				for (let x = 0; x <= days; x++) {
					daysTypes[x] = false;
				}
				let day = days;
				while (day > 0) {
					if (choices[day]) {
						let choice = choices[day];
						for (let x = day; x > day - choice.freeDays; x--) {
							daysTypes[x] = true;
						}

						day -= choice.freeDays + choice.discount.count_days;
					} else {
						break;
					}
				}

				let dates = this.date
					.split(/[^\d.]+/g)
					.map(date => date.split('.').reverse().join('-'))
					.sort();
				daysTypes.shift();
				this.discountDays = daysTypes.filter(type => type).length;
				let daysMap = {};
				for (let x = 0; x < days; x++) {
					daysMap[dates[x]] = daysTypes[x];
				}
				this.daysMap = daysMap;

				let daysElems = Array.from(document.querySelectorAll('.flatpickr-day.selected'));

				Array.from(document.querySelectorAll('.bg-border-blue'))
					.forEach(elem => elem.classList.remove('bg-border-blue'));
				daysElems.forEach(elem => {
					let date = formatDate(elem.dateObj);
					if (daysMap[date]) {
						elem.classList.add('bg-border-blue');
					}
				});

				return sums[days];
			},
			discounts() {
				let discounts = [];
				this.currentPath.forEach(el => {
					discounts = discounts.concat(el.discounts || []);
				});
				discounts.forEach(el => el.totalDays = +el.count_days + +el.extra_days);
				discounts.sort((a, b) => {
					if (a.totalDays > b.totalDays) {
						return 1;
					} else if (a.totalDays < b.totalDays) {
						return -1;
					} else {
						return 0;
					}
				});
				return discounts;
			},
		},
		methods: {
			declOfNum(number, titles) {
				let cases = [2, 0, 1, 1, 1, 2];
				return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
			},
			totalCount() {
				let count = 0;
				let phone = this.phone;
				let val = this.content;
				// дубликат в App\Order.php
				let phoneRegExp = /((Т|Тел)\.:?)?((\+?\d ?)?\(\d{3,4}\) ?)?((\d\d\d-\d\d\d)|(\d\d\d-\d\d-\d\d)),?/ig;
				let numRegexp = /\d-[^ \-\d]+/;
				[phoneRegExp, numRegexp].map(regExp => {
					let match = val.match(regExp);
					if (match) {
						// count += match.length;
						// val = val.replace(regExp, ' ');
						this.contentValid = false;
						this.errorMessage = 'Поля для телефона расположено ниже';
					}
					let ser = phone.match(regExp);
					if (ser) {
						count += ser.length;
						val = val.replace(regExp, ' ');
					}
				});
				val = val.split(/[ \-\r\n]/);
				count += val.filter(el => el.length).length;
				this.wordCount = count;
			},
			submit() {
				if (!this.agree) {
					return;
				}
				if (!this.content) {
					this.contentValid = false;
				}
				if (!this.date) {
					this.dateValid = false;
				}
				if (!this.userName) {
					this.userNameValid = false;
				}

				let contentPhone = this.phone;
				contentPhone = contentPhone.replace(/\D/g, '');
				if (contentPhone.length !== 11) {
					this.phoneValid = false;
				}

				let phone = this.userPhone;
				phone = phone.replace(/\D/g, '');
				if (phone.length !== 11) {
					this.userPhoneValid = false;
				}

				if (
					!this.contentValid ||
					!this.dateValid ||
					!this.userNameValid ||
					!this.userPhoneValid ||
					!this.phoneValid
				) {
					return;
				}
				let dates = this.date.split(/[^\d.]+/g);
				dates = dates.map(str => str.split('.').reverse().join('-'));
				let data = {
					name: this.userName,
					phone: this.userPhone,
					content: this.content,
					content_phone: this.phone,
					dates,
					category_id: this.currentPath[this.currentPath.length - 1].id,
					capital: this.capital,
				};
				this.loading = true;

				let createOrderUrl = '/ajax/create-order';

				let searchParams = new URLSearchParams(window.location.search);
				let secretKey = searchParams.get('s');
				if (secretKey) {
					createOrderUrl += '?s=' + secretKey;
				}

				axios
					.post(createOrderUrl, data)
					.then((response) => {
						if (window.self !== window.top) {
							window.top.location = response.data.link;
						} else {
							window.location = response.data.link;
						}
					})
					.catch((e) => {
						this.errorMessage =
							e.response && e.response.data && e.response.data.message ||
							'Произошла ошибка, пожалуйста, попробуйте позже';
					})
					.finally(() => {
						this.loading = false;
					});
			},
		},
		watch: {
			content(val = '') {
				this.totalCount(); //val
			},
			phone() {
				this.totalCount();
			}
		}
	}
</script>
